import { h, Fragment } from "preact";
import sanitizeOptionValue from "../../helpers/sanitizeOptionValue";

export default function ProductOptionInlineHeader({
  optionName,
  selectedOptionValue,
}) {
  return (
    <div className="product-options__inline-header">
      <div className="product-options__inline-name">{optionName}</div>
      <div className="product-options__inline-selected-value">
        {sanitizeOptionValue(selectedOptionValue)}
      </div>
    </div>
  );
}
